import { render } from "./PhoneCode.vue?vue&type=template&id=9d630f1e"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"

import "../PhoneCodePicker/phone.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__